// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"255":"c41373013ea7b655","308":"cdf3dda4139e0e20"}[chunkId] + ".css";
};